export const REGULATOR_REPORTING_RUNS_PATH =
  "/admin-panel-regulators/v1/runs";

export type ReportingRunListOrder = "asc" | "desc";

export const buildReportingRunsPath = (
  order: ReportingRunListOrder = "desc",
): string => {
  const params = new URLSearchParams({ order });
  return `${REGULATOR_REPORTING_RUNS_PATH}?${params.toString()}`;
};

export const buildReportingRunPath = (runId: string): string =>
  `${REGULATOR_REPORTING_RUNS_PATH}/${encodeURIComponent(runId)}`;

export const buildReportingDownloadPath = (runId: string): string =>
  `${buildReportingRunPath(runId)}/downloads`;
